/**
 * Sub Nav.
 */

export function SubNavInit() {
	const select = document.getElementById( 'page-sub-nav' );
	if ( ! select ) {
		return;
	}

	select.addEventListener( 'change', function ( e ) {
		window.location = e.target.value;
	} );
}